module.exports = __webpack_public_path__ + "static/media/avatar.12b69c03.png";